// Imports for external libraries go here.
import React, { FC, useEffect, useState } from 'react';
import DOMPurify from 'isomorphic-dompurify';
import { Config, EditableComponent, MappedComponentProperties } from '@adobe/aem-react-editable-components';
// Imports for internal (to the monorepo) libraries go here,
// separated by a blank line from external imports.
// The closer the import is to the file the lower it should be in this list.
import { TermsOfUseProps } from './TermsOfUse.types';
import { StyledTermsOfUse } from './TermsOfUse.styles';

const { NEXT_PUBLIC_AEM_SITE } = process.env;

// Use named rather than default exports.
export const TermsOfUse: FC<TermsOfUseProps> = ({ ppv5RTE }) => {
  const [termsOfUse, setTermsOfUse] = useState<string | TrustedHTML>('');

  const sanitize = (text: string): string | TrustedHTML => {
    return (
      DOMPurify.sanitize(text?.toString(), {
        ADD_ATTR: ['target'],
        RETURN_DOM: true,
      }) as HTMLElement
    ).innerHTML;
  };

  useEffect(() => {
    const termsOfUse = sanitize(ppv5RTE);
    setTermsOfUse(termsOfUse);
  }, [ppv5RTE]);

  return (
    <StyledTermsOfUse
      data-testid="ppv5-TermsOfUse"
      data-component-name="o-ppv5-TermsOfUse"
      className="my-4 py-4 container"
    >
      {termsOfUse && (
        <p
          data-testid="terms-of-use"
          dangerouslySetInnerHTML={{
            __html: termsOfUse,
          }}
        ></p>
      )}
    </StyledTermsOfUse>
  );
};

export const TermsOfUseConfig = {
  emptyLabel: 'TermsOfUseComponnet',
  isEmpty: (_props: MappedComponentProperties) => false,
  resourceType: `${NEXT_PUBLIC_AEM_SITE}/components/content/ppv5-rte`,
} as Config<MappedComponentProperties>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const TermsOfUseEditable = (props: TermsOfUseProps) => {
  return (
    <div data-testid="terms-of-use-editable" className="standard">
      <EditableComponent config={TermsOfUseConfig} {...props}>
        <TermsOfUse {...props} />
      </EditableComponent>
    </div>
  );
};
